import { PROJECT_SLUGS, SB_FOLDER_BY_PROJECT_SLUG } from '@monoimin/constants';

import { splitSlug } from './splitSlug';

export const defineProjectByFullSlug = (
  fullSlug: string
): (typeof PROJECT_SLUGS)[keyof typeof PROJECT_SLUGS] | null => {
  const splittedSlug = splitSlug(fullSlug);

  const [firstSegment] = splittedSlug;

  if (firstSegment === SB_FOLDER_BY_PROJECT_SLUG.monoimin) {
    return PROJECT_SLUGS.MONOIMIN;
  }

  if (firstSegment === SB_FOLDER_BY_PROJECT_SLUG['golden-visa']) {
    return PROJECT_SLUGS.GOLDEN_VISA;
  }

  if (firstSegment === SB_FOLDER_BY_PROJECT_SLUG.minisites) {
    return PROJECT_SLUGS.MINISITES;
  }

  if (firstSegment === SB_FOLDER_BY_PROJECT_SLUG['passport-rating']) {
    return PROJECT_SLUGS.PASSPORT_RATING;
  }

  if (firstSegment === SB_FOLDER_BY_PROJECT_SLUG.passportivity) {
    return PROJECT_SLUGS.PASSPORTIVITY;
  }

  return null;
};

export default defineProjectByFullSlug;
